export const croAnalyticsTableHeader = [
  {
    field: 'sl_no',
    headerName: 'Sl No.',
    width: 120,
  },
  {
    field: 'croName',
    headerName: 'CRO Name',
    width: 250,
    toolTipGetter: true,
    sortable: true,
  },
  {
    field: 'course_name',
    headerName: 'Course',
    width: 250,
    toolTipGetter: true,
  },
  {
    field: 'total_leads',
    headerName: 'Total Leads',
    width: 170,
    sortable: true,
  },
  {
    field: 'Not Attended',
    headerName: 'Not Attended',
    width: 170,
    sortable: true,
  },
  {
    field: 'Admission Confirmed',
    headerName: 'Admission Confirmed',
    width: 220,
    sortable: true,
  },
  {
    field: 'Waiting For Response',
    headerName: 'Waiting For Response',
    width: 230,
    sortable: true,
  },
  {
    field: 'Demo Class Scheduled',
    headerName: 'Demo Class Scheduled',
    width: 230,
    sortable: true,
  },
  {
    field: 'Postponed',
    headerName: 'Postponed',
    width: 140,
    sortable: true,
  },
  {
    field: 'Response Issue',
    headerName: 'Response Issue',
    width: 180,
    sortable: true,
  },
  {
    field: 'Not Reachable',
    headerName: 'Not Reachable',
    width: 180,
    sortable: true,
  },
  {
    field: 'Cancelled',
    headerName: 'Cancelled',
    width: 150,
    sortable: true,
  },
  {
    field: 'Expelled',
    headerName: 'Expelled',
    width: 150,
    sortable: true,
  },
  {
    field: 'conversion_percentage',
    headerName: '% of Conversion',
    width: 240,
    sortable: true,
  },
  {
    field: 'pending_response_percentage',
    headerName: '% of Pending Response',
    width: 240,
    sortable: true,
  },
];
